<template>
  <div class="deposit-container">
    <!-- 统计卡片 -->
    <!-- <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon income">
          <i class="fas fa-arrow-down"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">{{ $t('_cb._zrz') }}</div>
          <div class="stat-value">${{ totalIncome }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon count">
          <i class="fas fa-list"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">{{ $t('_cb._jybs') }}</div>
          <div class="stat-value">{{ transactions.length }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon recent">
          <i class="fas fa-clock"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">{{ $t('_cb._zjj y') }}</div>
          <div class="stat-time">{{ latestTransaction }}</div>
        </div>
      </div>
    </div> -->

    <!-- 搜索栏 -->
    <!-- <div class="filter-bar">
      <div class="search-box">
        <i class="fas fa-search"></i>
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('_cb._ssdz')"
          class="search-input"
          @input="onSearch"
        />
      </div>
    </div> -->

    <!-- 交易列表 -->
    <div class="table-wrapper">
      <div class="table-header">
        <div class="header-cell" style="flex: 2">{{ $t('_cb._bz') }}</div>
        <div class="header-cell" style="flex: 1.5">{{ $t('_cb._je') }}</div>
        <div class="header-cell" style="flex: 3.5">{{ $t('_cb._dz') }}</div>
        <div class="header-cell" style="flex: 1.5">{{ $t('_cb._sj') }}</div>
        <div class="header-cell" style="flex: 1">{{ $t('_cb._cz') }}</div>
      </div>

      <!-- 列表项 -->
      <div
        v-for="item in transactions"
        :key="item.id"
        class="table-row"
      >
        <div class="row-cell" style="flex: 2">
          <div class="currency-info">
            <div class="currency-name">{{ item.name }}</div>
            <div class="currency-network">{{ item.network }}</div>
          </div>
        </div>

        <div class="row-cell" style="flex: 1.5">
          <span class="amount income">+${{ item.real_number }}</span>
        </div>

        <div class="row-cell" style="flex: 3.5">
          <div class="address-cell">
            <span class="address-text">{{ formatAddress(item.address) }}</span>
            <button class="copy-btn" @click="copyAddress(item.address)">
              <CopyOutlined />
            </button>
          </div>
        </div>

        <div class="row-cell" style="flex: 1.5">
          <div class="time-info">
            <div class="time-date">{{ formatDate(item.create_time) }}</div>
            <div class="time-hour">{{ formatTime(item.create_time) }}</div>
          </div>
        </div>

        <div class="row-cell" style="flex: 1">
          <button class="view-btn" @click="viewDetails(item)">
            <EyeOutlined />
          </button>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="transactions.length === 0 && !loading" class="empty-state">
        <i class="fas fa-inbox"></i>
        <p>{{ $t('_cb._zwjl') }}</p>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-bar" v-if="transactions.length > 0">
      <button class="page-btn" :disabled="page === 1" @click="onPage(page - 1)">
        <LeftOutlined />
      </button>
      <span class="page-info">{{ $t('_cb._dny', { a: page, b: totalPages }) }}</span>
      <button class="page-btn" :disabled="page === totalPages" @click="onPage(page + 1)">
        <RightOutlined />
      </button>
    </div>

    <!-- 详情弹窗 -->
    <div v-if="selectedItem" class="modal-overlay" @click.self="selectedItem = null">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">{{ $t('_cb._jyxq') }}</span>
          <button class="modal-close" @click="selectedItem = null">
            <CloseCircleOutlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-item">
            <span class="detail-label">{{ $t('_cb._jydz') }}</span>
            <span class="detail-value address">{{ selectedItem.address }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_cb._bz') }}</span>
            <span class="detail-value">{{ selectedItem.name }} ({{ selectedItem.network }})</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_cb._je') }}</span>
            <span class="detail-value amount">+${{ selectedItem.real_number }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_cb._sj') }}</span>
            <span class="detail-value">{{ formatFullTime(selectedItem.create_time) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_cb._zt') }}</span>
            <span class="status-badge confirmed">{{ $t('_cb._yqr') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CopyOutlined, EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'

export default {
  name: 'DepositRecords',
  components: {
    CopyOutlined,
    EyeOutlined,
    RightOutlined,
    LeftOutlined,
    CloseCircleOutlined
  },
  data() {
    return {
      searchQuery: '',
      transactions: [],
      selectedItem: null,
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      searchTimer: null
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    },
    totalIncome() {
      return this.transactions.reduce((sum, t) => sum + parseFloat(t.real_number || 0), 0).toFixed(2)
    },
    latestTransaction() {
      if (this.transactions.length === 0) return this.$t('_cb._zw')
      const latest = this.transactions.slice().sort((a, b) => b.create_time - a.create_time)[0]
      return this.formatTime(latest.create_time)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      this.$api.userWallet
        .getReceiveList({
          page: this.page,
          size: this.pageSize,
          search: this.searchQuery
        })
        .then((res) => {
          hide()
          this.transactions = res.data?.data || []
          this.total = res.data?.total || 0
        })
        .catch(() => {
          hide()
          this.transactions = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    onSearch() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.page = 1
        this.getList()
      }, 300)
    },

    onPage(page) {
      if (page < 1 || page > this.totalPages) return
      this.page = page
      this.getList()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    formatAddress(address) {
      if (!address) return ''
      if (address.length <= 16) return address
      return address.substring(0, 8) + '...' + address.substring(address.length - 8)
    },

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('zh-CN')
    },

    formatTime(date) {
      if (!date) return ''
      return new Date(date).toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    formatFullTime(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN')
    },

    copyAddress(address) {
      if (!address) return
      navigator.clipboard.writeText(address).then(() => {
        this.$message.success(this.$t('_cb._fzcg'))
      }).catch(() => {
        // 降级方案
        const input = document.createElement('input')
        input.value = address
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success(this.$t('_cb._fzcg'))
      })
    },

    viewDetails(item) {
      this.selectedItem = item
    }
  }
}
</script>

<style scoped>
/* ============================================================
   存币记录 - 暗色主题
   ============================================================ */

.deposit-container {
  background: transparent;
  color: #e8edf2;
}

/* ============================================================
   搜索栏
   ============================================================ */
.filter-bar {
  margin-bottom: 20px;
}

.search-box {
  display: flex;
  align-items: center;
  background: #181e24;
  border-radius: 24px;
  padding: 0 16px;
  border: 1px solid #1e262e;
  transition: border-color 0.3s, box-shadow 0.3s;
  max-width: 360px;
}

.search-box:focus-within {
  border-color: #e50914;
  box-shadow: 0 0 0 3px rgba(229, 9, 20, 0.1);
}

.search-box i {
  color: #5a6672;
  font-size: 14px;
  margin-right: 10px;
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #e8edf2;
  font-size: 14px;
  padding: 9px 0;
}

.search-input::placeholder {
  color: #4a5662;
}

/* ============================================================
   表格
   ============================================================ */
.table-wrapper {
  background: #0f1419;
  border-radius: 14px;
  border: 1px solid #1a1f26;
  overflow: hidden;
}

/* 表头 */
.table-header {
  display: flex;
  padding: 12px 20px;
  background: #0a0d0f;
  border-bottom: 1px solid #1a1f26;
}

.header-cell {
  color: #5a6672;
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 行 */
.table-row {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #141a20;
  transition: background 0.2s;
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.02);
}

.table-row:last-child {
  border-bottom: none;
}

.row-cell {
  display: flex;
  align-items: center;
  padding: 0 6px;
  min-height: 44px;
}

/* ============================================================
   货币信息
   ============================================================ */
.currency-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.currency-name {
  color: #e8edf2;
  font-size: 14px;
  font-weight: 500;
}

.currency-network {
  color: #5a6672;
  font-size: 12px;
}

/* ============================================================
   金额
   ============================================================ */
.amount {
  font-size: 15px;
  font-weight: 600;
}

.amount.income {
  color: #26a69a;
}

.amount.income .amount-symbol {
  margin-right: 2px;
}

/* ============================================================
   地址
   ============================================================ */
.address-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.address-text {
  color: #8a949f;
  font-size: 14px;
  font-family: monospace;
  letter-spacing: 0.3px;
}

.copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #5a6672;
  cursor: pointer;
  transition: all 0.2s;
}

.copy-btn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #e8edf2;
}

/* ============================================================
   时间
   ============================================================ */
.time-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.time-date {
  color: #e8edf2;
  font-size: 13px;
}

.time-hour {
  color: #5a6672;
  font-size: 12px;
}

/* ============================================================
   操作按钮
   ============================================================ */
.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #5a6672;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
}

.view-btn:hover {
  background: rgba(229, 9, 20, 0.12);
  color: #e50914;
}

/* ============================================================
   空状态
   ============================================================ */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #5a6672;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.4;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* ============================================================
   分页
   ============================================================ */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 0 0;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #1a1f26;
  border-radius: 8px;
  background: #0f1419;
  color: #8a949f;
  cursor: pointer;
  transition: all 0.25s;
}

.page-btn:hover:not(:disabled) {
  background: #181e24;
  border-color: #2a3138;
  color: #e8edf2;
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-info {
  color: #8a949f;
  font-size: 14px;
}

/* ============================================================
   详情弹窗
   ============================================================ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.25s ease;
}

.modal-content {
  width: 420px;
  max-width: 92vw;
  background: #141a20;
  border-radius: 16px;
  border: 1px solid #1e262e;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  animation: slideUp 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #1a1f26;
}

.modal-title {
  color: #e8edf2;
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #5a6672;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.25s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #e8edf2;
  transform: rotate(90deg);
}

.modal-body {
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  color: #5a6672;
  font-size: 14px;
}

.detail-value {
  color: #e8edf2;
  font-size: 14px;
  font-weight: 500;
}

.detail-value.address {
  color: #8a949f;
  font-family: monospace;
  font-size: 13px;
  max-width: 200px;
  word-break: break-all;
}

.detail-value.amount {
  color: #26a69a;
}

.status-badge {
  padding: 2px 14px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.confirmed {
  background: rgba(38, 166, 154, 0.15);
  color: #26a69a;
}

/* ============================================================
   动画
   ============================================================ */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .table-header {
    display: none;
  }

  .table-row {
    flex-direction: column;
    align-items: stretch;
    padding: 14px 16px;
    gap: 8px;
  }

  .row-cell {
    padding: 0;
    min-height: auto;
  }

  .row-cell[style*="flex: 3.5"] {
    order: 3;
  }

  .row-cell[style*="flex: 1.5"]:nth-child(4) {
    order: 4;
  }

  .row-cell[style*="flex: 1"] {
    order: 5;
    justify-content: flex-end;
  }

  .address-text {
    font-size: 13px;
  }

  .modal-content {
    width: 95vw;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .detail-value.address {
    max-width: 100%;
    word-break: break-all;
  }
}

@media (max-width: 480px) {
  .search-box {
    max-width: 100%;
  }

  .table-row {
    padding: 12px 14px;
    gap: 6px;
  }

  .currency-name {
    font-size: 13px;
  }

  .amount {
    font-size: 14px;
  }

  .time-date {
    font-size: 12px;
  }
}
</style>